import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class VerifyAuthenticationUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {getCurrentUserUseCaseService} deps.service
   * @param {repository} deps.repository
   * @param {Object} deps.log
   */
  constructor({config, log, service}) {
    super({
      config,
      log,
      service
    })
    this._config = config
    this._log = log
    this._service = service
  }

  /**
   * @return {Promise<Object, Error>}
   */
  execute = () => this._service.execute()
}
